import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RazaoContabilComponent } from './razao-contabil.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        PoModule,
        PoPageDynamicTableModule,
        PoPageDynamicEditModule,
        SharedModule
  ],
  declarations: [RazaoContabilComponent]
})
export class RazaoContabilModule { }
